import { render } from "./Regist.vue?vue&type=template&id=43eb6ea7&scoped=true"
import script from "./Regist.vue?vue&type=script&lang=js"
export * from "./Regist.vue?vue&type=script&lang=js"

import "./Regist.vue?vue&type=style&index=0&id=43eb6ea7&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43eb6ea7"]])

export default __exports__